var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNutzer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Nutzer__Icn/40px/Nutzer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Nutzer__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Nutzer__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22,20 C25.8659932,20 29,23.1340068 29,27 L29,31 L11,31 L11,27 C11,23.1340068 14.1340068,20 18,20 L22,20 Z M22,22 L18,22 C15.3112453,22 13.1181819,24.1223067 13.0046195,26.7831104 L13,27 L13,29 L27,29 L27,27 C27,24.3112453 24.8776933,22.1181819 22.2168896,22.0046195 L22,22 Z M19.7629097,8 C22.8004758,8 25.2629097,10.4624339 25.2629097,13.5 C25.2629097,16.5375661 22.8004758,19 19.7629097,19 C16.7253435,19 14.2629097,16.5375661 14.2629097,13.5 C14.2629097,10.4624339 16.7253435,8 19.7629097,8 Z M19.7629097,10 C17.829913,10 16.2629097,11.5670034 16.2629097,13.5 C16.2629097,15.4329966 17.829913,17 19.7629097,17 C21.6959063,17 23.2629097,15.4329966 23.2629097,13.5 C23.2629097,11.5670034 21.6959063,10 19.7629097,10 Z",
    id: ".._.._src_svg_Icn_40px_Nutzer__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutzer);
export default __webpack_public_path__ + "static/media/Nutzer.fcce1df1fa3835fd58e52fedd57204d6.svg";
export { ForwardRef as ReactComponent };